import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { NotesField } from '../components/NotesField';
import { ProductGallery } from '../components/ProductGallery';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';
import { CustomSizeField } from '../components/CustomSizeField';

const title = "Badges & Name Tags - INGAZ Print";

function Badges() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          <section className="product-details-section">
            <div className="product-container">
              <ProductGallery alt="Badges & Name Tags" images={[asset('assets/badge.png'), asset('assets/badge_detail_new.png'), asset('assets/badge_stack_new.png'), asset('assets/badges_usage.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Badges" data-ar="الشارات">Badges</h1>
                <p className="product-description" data-en="Professional name badges and ID tags for events, conferences, and workplace identification." data-ar="شارات أسماء وبطاقات تعريف احترافية للفعاليات والمؤتمرات وتعريف مكان العمل.">Professional name
                  badges and ID tags for events, conferences, and workplace identification.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Quick identification at events and workplaces" data-ar="تعريف سريع في الفعاليات وأماكن العمل">
                      Quick identification at events and workplaces</li>
                    <li data-en="Reusable options with replaceable inserts" data-ar="خيارات قابلة لإعادة الاستخدام مع إدخالات قابلة للاستبدال">
                      Reusable options with replaceable inserts</li>
                    <li data-en="Professional appearance for your team" data-ar="مظهر احترافي لفريقك">
                      Professional appearance for your team</li>
                    <li data-en="Multiple attachment options available" data-ar="خيارات تثبيت متعددة متاحة">
                      Multiple attachment options available</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/bag.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Conferences" data-ar="المؤتمرات">Conferences</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Workplaces" data-ar="أماكن العمل">Workplaces</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Trade Shows" data-ar="المعارض التجارية">Trade Shows</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Team Events" data-ar="فعاليات الفريق">Team Events</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Badges" data-ar="قم بتكوين الشارات الخاصة بك">Configure Your Badges</h2>
                
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>

                {/* Badge material */}
                <div className="config-group">
                  <label htmlFor="badgeMaterial" data-en="Badge material" data-ar="مادة الشارة">Badge material</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="badgeMaterial">
                      <option value="coated-paper" data-en="Coated paper (laminated)" data-ar="ورق مطلي (مغلف)">Coated paper (laminated)</option>
                      <option value="pvc-plastic" data-en="PVC plastic" data-ar="بلاستيك PVC">PVC plastic</option>
                      <option value="metal" data-en="Metal (engraved / printed)" data-ar="معدن (محفور / مطبوع)">Metal (engraved / printed)</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>

                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="standard" data-dims="90x54 mm"><span data-en="Standard" data-ar="قياسي">Standard</span><br /><span>90x54</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Other" data-ar="آخر">Other</span><br /><span data-en="Custom" data-ar="مخصص">Custom</span></div>
                  </div>
                  <CustomSizeField />
                </div>

                {/* Shape */}
                <div className="config-group">
                  <label data-en="Shape" data-ar="الشكل">Shape</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="shape" defaultValue="rectangle" defaultChecked />
                      <span data-en="Rectangle" data-ar="مستطيل">Rectangle</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="shape" defaultValue="rounded-corners" />
                      <span data-en="Rounded corners" data-ar="زوايا دائرية">Rounded corners</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="shape" defaultValue="custom" />
                      <span data-en="Custom shape" data-ar="شكل مخصص">Custom shape</span>
                    </label>
                  </div>
                </div>

                {/* Attachment method */}
                <div className="config-group">
                  <label data-en="Attachment method" data-ar="طريقة التثبيت">Attachment method</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="attachment" defaultValue="pin" defaultChecked />
                      <span data-en="Pin (safety pin)" data-ar="دبوس (دبوس أمان)">Pin (safety pin)</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="attachment" defaultValue="magnetic" />
                      <span data-en="Magnetic back" data-ar="ظهر مغناطيسي">Magnetic back</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="attachment" defaultValue="lanyard-hole" />
                      <span data-en="Lanyard hole only" data-ar="ثقب للشريط فقط">Lanyard hole only</span>
                    </label>
                  </div>
                </div>

                {/* Personalization */}
                <div className="config-group">
                  <label data-en="Personalization (variable data)" data-ar="التخصيص (بيانات متغيرة)">Personalization (variable data)</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="personalization" defaultValue="standard" defaultChecked onChange={(e) => document.getElementById('personalizationListUpload').style.display = 'none'} />
                      <span data-en="No personalization (same design for all)" data-ar="بدون تخصيص (نفس التصميم للجميع)">No personalization (same design for all)</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="personalization" defaultValue="personalized" onChange={(e) => document.getElementById('personalizationListUpload').style.display = 'block'} />
                      <span data-en="Personalized (names / titles differ per badge)" data-ar="مخصص (تختلف الأسماء / الألقاب لكل شارة)">Personalized (names / titles differ per badge)</span>
                    </label>
                  </div>
                  
                  <div id="personalizationListUpload" style={{display: 'none', marginTop: '15px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px dashed #ced4da'}}>
                    <strong style={{display: 'block', marginBottom: '8px'}} data-en="Attach a list with the details for each badge" data-ar="أرفق قائمة بالتفاصيل لكل شارة">Attach a list with the details for each badge</strong>
                    <input type="file" id="namesListFile" accept=".xlsx,.xls,.csv" style={{width: '100%'}} />
                  </div>
                </div>

                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                
                {/* Upload Design Files */}
                <div className="config-group">
                  <label data-en="Upload artwork" data-ar="رفع العمل الفني">Upload artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here
                        or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS,
                        PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>

                <NotesField />
              </div>
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Material:" data-ar="المادة:">Material:</span>
                    <span className="summary-value" id="summaryBadgeMaterial">Coated paper (laminated)</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">Standard</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Personalization:" data-ar="التخصيص:">Personalization:</span>
                    <span className="summary-value" id="summaryPersonalization">No personalization</span>
                  </div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
              </div>
            </div>
          </section>
          <SiteFooter />
        </main>
    </>
  );
}

export default Badges;
